/** AI 智慧選課(ai.html)進入點。 */
import '../loading';
import { initAdvisor } from '../ai-advisor';
import { initStudentPage } from '../dashboard';

void (async () => {
  await initStudentPage();
  initAdvisor();
})();
